import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from '@hopskipdrive/react-components';

import { PageErrorFallback } from '../../shared/components/PageErrorFallback';
import { QueryErrorState } from '../../shared/components/QueryErrorState';
import { ErrorBoundary } from '../../utils/errorReporting/ErrorBoundary';
import { useRideEditorScope, useRideEditorSession } from '../hooks/useRideEditor';

const RidePageContent = ({ children }: { children: ReactElement }) => {
  const { rideId } = useParams();
  const { ready, rideDetails, isLoadingError, fetchRideDetails, isFetching } = useRideEditorSession();

  if (isLoadingError) {
    return (
      <QueryErrorState
        message="Unable to load this ride. Please try again."
        tableHeightOffset={0}
        onRetry={() => fetchRideDetails(rideId)}
      />
    );
  }

  if (!ready || (rideId && !rideDetails && isFetching)) {
    return <Loader />;
  }

  return children;
};

export const RidePage = ({ children }: { children: ReactElement }) => {
  const scope = useRideEditorScope();

  return (
    <ErrorBoundary FallbackComponent={PageErrorFallback}>
      <RidePageContent key={scope}>{children}</RidePageContent>
    </ErrorBoundary>
  );
};
